import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function SignupConfirmation({ signupConfirm, setSignupConfirm, role }) {
  const navigate = useNavigate();
  const handleSignupConfirm = () => {
    setSignupConfirm(!signupConfirm);
    navigate("/log-in");
  };
  return (
    <>
      <Modal
        size="sm"
        centered
        show={signupConfirm}
        onHide={handleSignupConfirm}
      >
        <Modal.Body>
          <div className="text-center">
            <h6 className="m-0 fw-bold">
              Please check your email for your Login{" "}
              {role !== "4" ? "ID: PT-XXX or DR-ZZZ" : ""}
            </h6>
          </div>
          <div className="btnWrpper text-center mt-4">
            <Button
              className="d-inline-flex px-4 items-center justify-center"
              onClick={handleSignupConfirm}
            >
              ok
            </Button>
          </div>
        </Modal.Body>{" "}
      </Modal>
    </>
  );
}

// export default SignupConfirmation
